import React from "react";

const HeroSection = () => {
  return (
    <div className="mb-4 relative">
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-wide bg-gradient-to-r from-white via-indigo-100 to-violet-400 bg-clip-text text-transparent drop-shadow-lg">
        ASK HR
      </h1>
      <p className="mt-2 text-sm sm:text-base text-slate-100/90 max-w-xl mx-auto">
        Welcome to your HR support center and get instant assistance with
        all your HR-related needs.
      </p>
      <div className="h-4" />
    </div>
  );
};

export default HeroSection;

